export default __webpack_public_path__ + "static/media/810.4bb07464.jpg";